<template>
  <div class="reset-form">
    <loading :active.sync="is_loading"></loading>
    <b-form @submit="onSubmitReset">
      <b-form-group
        id="email-group"
        label="Ingresa tu correo electrónico"
        label-for="email"
      >
        <b-form-input
          @click.right.prevent
          @copy.prevent
          @paste.prevent
          id="email"
          v-model="email"
          type="email"
          required
          placeholder="ejemplo@mail.com"
        ></b-form-input>
      </b-form-group>
      <div class="alert alert-warning" v-if="showResponse">
        {{ mensaje }}
      </div>
      <b-button
        class="btn text-light"
        type="submit"
        style="
          background: #0f182b;
          font-weight: bold;
          width: 175px;
          height: 40px;
        "
      >
        Recuperar
      </b-button>
    </b-form>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

const axios = require("axios");

export default {
  name: "ResetForm",
  data() {
    return {
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
      email: "",
      showResponse: false,
      mensaje: "",
      is_loading: false,
      urlDinamica: "",
    };
  },
  created() {
    this.urlDinamica = window.location.origin;
  },
  methods: {
    onSubmitReset: function (e) {
      e.preventDefault();
      this.is_loading = true;
      if ($cookies.isKey("ctoken")) {
        axios({
          method: "POST",
          url: this.api_url + "/password/email",
          data: {
            email: this.email,
            route: this.urlDinamica + "/resetpassword",
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("ctoken"),
          },
        })
          .then((response) => {
            this.is_loading = false;
            // Verificar la respuesta para saber si el email existe en la base de datos
            if (response.data.status === false) {
              // Si no existe
              this.showResponse = true;
              this.mensaje = response.data.data.email[0];
              setTimeout(() => {
                this.showResponse = false;
              }, 4000);
            } else {
              // Si existe
              this.showResponse = true;
              this.mensaje = response.data.message;
              setTimeout(() => {
                this.showResponse = false;
                this.$router.push("/");
              }, 4000);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.$snotify.info("No se ha podido enviar el correo");
      }
    },
  },
  components: {
    Loading,
  },
};
</script>

<style>
</style>